<template>
  <div v-show="show" class="pre-export-component-template">
    <div class="bro-check-body">
        <p class="bro-check-header">{{ $t('preExport.SIKBValidationType.label.header') }}</p>
        <p class="bro-check-explanation">{{ $t('preExport.SIKBValidationType.label.explanation') }}</p>

        <DxSelectBox v-model="selectedValidationValueForSIKB" class="validation-sikb-select" :data-source="validations" display-expr=displayValue
            value-expr="value" @value-changed="updateSelectedValidationValueForSIKB" />
    </div>
  </div>
</template>

<script>
import '@/assets/less/colors.less'

import DxSelectBox from 'devextreme-vue/select-box'

export default {
  name: 'SIKBValidationSelector',
  data() {
    return {
      validations: [
        {
          value: 'Undefined',
          conversionContextValue: 'Undefined',
          displayValue: this.$t('preExport.SIKBValidationType.reasons.NoCheck')
        },
        {
          value: 'IMBRO_Registration',
          conversionContextValue: 'IMBRO',
          displayValue: this.$t('preExport.SIKBValidationType.reasons.RegisterIMBRO'),
          correction: false
        },
        {
          value: 'IMBRO_Correction',
          conversionContextValue: 'IMBRO',
          displayValue: this.$t('preExport.SIKBValidationType.reasons.CorrectionIMBRO'),
          correction: true
        },
        {
          value: 'IMBRO/A_Registration',
          conversionContextValue: 'IMBRO/A',
          displayValue: this.$t('preExport.SIKBValidationType.reasons.RegisterIMBROA'),
          correction: false
        },
        {
          value: 'IMBRO/A_Correction',
          conversionContextValue: 'IMBRO/A',
          displayValue: this.$t('preExport.SIKBValidationType.reasons.CorrectionIMBROA'),
          correction: true
        }
      ],
      selectedValidationValueForSIKB: 'IMBRO_Registration',
      show: true
    }
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  components: {
    DxSelectBox
  },
  mounted() {
    this.$emit('preExportCheckUpdated')
    this.$store.commit('updateExportProjectConversionContext', { PrID: this.projectId, conversionContext: { broQualityRegime: 'IMBRO' } })
  },
  methods: {
    updateSelectedValidationValueForSIKB(event) {
      const selected = this.$data.validations.find(validation => validation.value === this.selectedValidationValueForSIKB)
      if (typeof selected.conversionContextValue === 'undefined') {
        console.error('Unable to determine the selected value for validation; skipping validation.')
      } else {
        this.$store.commit('updateExportProjectConversionContext', { PrID: this.projectId, conversionContext: { broQualityRegime: selected.conversionContextValue, isCorrection: selected.correction } })
        this.$emit('preExportCheckUpdated')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pre-export-component-template {
  background: @gray100;
  padding: 16px;
}
.validation-sikb-select {
    width: 100%;
    height: 50px;
    border: 1px solid #dbd9d7;
    border-radius: 4px;
}
</style>
